import React from 'react';

import Button from '@pb/kit-component-button';
import {Group} from '@pb/kit-component-group';

type Props = {
    toPrevBlock?: () => void,
    toNextBlock: () => void,
    nextDisabled?: boolean,
    prevDisabled?: boolean,
    captionNext?: string,
};

export const BulkUpdateCrmIdsModalFooter = (props: Props) => {
    const {toPrevBlock, toNextBlock, nextDisabled, prevDisabled, captionNext} = props;
    return (
        <Group>
            {toPrevBlock ? (
                <Button variant="Type.PRIMARY" onClick={toPrevBlock} disabled={prevDisabled}>
                    Cancel
                </Button>
            ) : null}
            <Button variant="Type.PRIMARY" onClick={toNextBlock} disabled={nextDisabled}>
                {captionNext || 'Next'}
            </Button>
        </Group>
    );
};
